import React from "react";
import S from "./Steps.styled";

export interface Props {
  preTitle: string;
  title: string;
  text: string;
  steps: {
    icon: string;
    title: string;
    text: string;
  }[];
}

const PostsGrid: React.FC<Props> = ({ preTitle, title, text, steps }) => {
  return (
    <S.StepsContainer id="hur-det-gar-till" className={"relative"}>
      <div className="relative wrap overflow-hidden p-10 h-full md:mx-auto md:max-w-7xl">
        <h4 className="text-mGray-500 text-center m-0 pt-6">{preTitle}</h4>
        <h3 className="text-4xl text-center mt-0">{title}</h3>
        <p
          className="text-center pb-24 mx-auto sm:w-2/4 "
          dangerouslySetInnerHTML={{ __html: text }}
        ></p>

        <div
          className="border-2-2 absolute border-opacity-20 border-gray-700 h-full border"
          style={{ left: "50%" }}
        ></div>

        {steps.map((step, idx) => {
          if (idx % 2 === 0) {
            return (
              <div className="mb-8 flex justify-between items-center w-full right-timeline md:text-left text-center">
                <div className="order-1 w-5/12 hidden md:block"></div>
                <div className="z-20 flex items-center order-1 bg-mGray-100 pt-2 hidden md:block">
                  <h1 className="mx-auto font-semibold text-4xl">{idx + 1}</h1>
                </div>
                <div className="order-1 bg-gray-400 rounded-lg shadow-xl md:w-5/12 w-full px-6 py-4 z-10">
                  <h3 className="mb-3 font-bold text-xl mt-0 flex items-center md:justify-start justify-center">
                    <i className={step.icon + " mr-4 text-3xl"}></i>{" "}
                    {step.title}
                  </h3>
                  <p
                    className="text-md leading-snug tracking-wide text-gray-900 text-opacity-100"
                    dangerouslySetInnerHTML={{ __html: step.text }}
                  ></p>
                </div>
              </div>
            );
          } else {
            return (
              <div className="mb-8 flex justify-between flex-row-reverse items-center w-full left-timeline md:text-left text-center">
                <div className="order-1 w-5/12 hidden md:block"></div>
                <div className="z-20 flex items-center order-1 bg-mGray-100 pt-2 hidden md:block">
                  <h1 className="mx-auto font-semibold text-4xl">{idx + 1}</h1>
                </div>
                <div className="order-1 bg-metlab-500 rounded-lg shadow-xl md:w-5/12 w-full px-6 py-4 z-10">
                  <h3 className="mb-3 font-bold text-white text-xl mt-0 flex items-center md:justify-start justify-center">
                    <i className={step.icon + " mr-4 text-3xl"}></i>{" "}
                    {step.title}
                  </h3>
                  <p
                    className="text-md leading-snug tracking-wide text-white text-opacity-100"
                    dangerouslySetInnerHTML={{ __html: step.text }}
                  />
                </div>
              </div>
            );
          }
        })}
      </div>
    </S.StepsContainer>
  );
};

export default PostsGrid;
